// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "accept_url": {
      "column": {
        "default": null,
        "name": "accept_url",
        "null": false,
        "type": "string"
      },
      "name": "accept_url",
      "selected_by_default": null,
      "translated": null
    },
    "callback_enabled": {
      "column": {
        "default": false,
        "name": "callback_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "callback_enabled",
      "selected_by_default": null,
      "translated": null
    },
    "callback_url": {
      "column": {
        "default": null,
        "name": "callback_url",
        "null": false,
        "type": "string"
      },
      "name": "callback_url",
      "selected_by_default": null,
      "translated": null
    },
    "cancel_url": {
      "column": {
        "default": null,
        "name": "cancel_url",
        "null": false,
        "type": "string"
      },
      "name": "cancel_url",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "merchant_number": {
      "column": {
        "default": null,
        "name": "merchant_number",
        "null": false,
        "type": "string"
      },
      "name": "merchant_number",
      "selected_by_default": null,
      "translated": null
    },
    "access_token": {
      "column": null,
      "name": "access_token",
      "selected_by_default": null,
      "translated": null
    },
    "md5_key": {
      "column": null,
      "name": "md5_key",
      "selected_by_default": null,
      "translated": null
    },
    "secret_token": {
      "column": null,
      "name": "secret_token",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TenantBamboraSetting",
  "collectionKey": "tenant_bambora_settings",
  "collectionName": "tenant_bambora_settings",
  "i18nKey": "tenant_bambora_setting",
  "camelizedLower": "tenantBamboraSetting",
  "name": "TenantBamboraSetting",
  "nameDasherized": "tenant-bambora-setting",
  "pluralName": "tenant_bambora_settings",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "accept_url",
      "column": {
        "default": null,
        "name": "accept_url",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "callback_enabled",
      "column": {
        "default": false,
        "name": "callback_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "callback_url",
      "column": {
        "default": null,
        "name": "callback_url",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "cancel_url",
      "column": {
        "default": null,
        "name": "cancel_url",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "encrypted_access_token",
      "column": {
        "default": null,
        "name": "encrypted_access_token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "encrypted_access_token_iv",
      "column": {
        "default": null,
        "name": "encrypted_access_token_iv",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "encrypted_md5_key",
      "column": {
        "default": null,
        "name": "encrypted_md5_key",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "encrypted_md5_key_iv",
      "column": {
        "default": null,
        "name": "encrypted_md5_key_iv",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "encrypted_secret_token",
      "column": {
        "default": null,
        "name": "encrypted_secret_token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "encrypted_secret_token_iv",
      "column": {
        "default": null,
        "name": "encrypted_secret_token_iv",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "merchant_number",
      "column": {
        "default": null,
        "name": "merchant_number",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "tenant_bambora_setting",
  "primaryKey": "id"
}

/** Frontend model for TenantBamboraSetting. */
export default class TenantBamboraSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  acceptUrl() {
    return this.readAttributeUnderscore("accept_url")
  }

  /** @returns {boolean} */
  hasAcceptUrl() {
    const value = this.acceptUrl()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  callbackEnabled() {
    return this.readAttributeUnderscore("callback_enabled")
  }

  /** @returns {boolean} */
  hasCallbackEnabled() {
    const value = this.callbackEnabled()

    return this._isPresent(value)
  }

  /** @returns {string} */
  callbackUrl() {
    return this.readAttributeUnderscore("callback_url")
  }

  /** @returns {boolean} */
  hasCallbackUrl() {
    const value = this.callbackUrl()

    return this._isPresent(value)
  }

  /** @returns {string} */
  cancelUrl() {
    return this.readAttributeUnderscore("cancel_url")
  }

  /** @returns {boolean} */
  hasCancelUrl() {
    const value = this.cancelUrl()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  merchantNumber() {
    return this.readAttributeUnderscore("merchant_number")
  }

  /** @returns {boolean} */
  hasMerchantNumber() {
    const value = this.merchantNumber()

    return this._isPresent(value)
  }

  /** @returns {any} */
  accessToken() {
    return this.readAttributeUnderscore("access_token")
  }

  /** @returns {boolean} */
  hasAccessToken() {
    const value = this.accessToken()

    return this._isPresent(value)
  }

  /** @returns {any} */
  md5Key() {
    return this.readAttributeUnderscore("md5_key")
  }

  /** @returns {boolean} */
  hasMd5Key() {
    const value = this.md5Key()

    return this._isPresent(value)
  }

  /** @returns {any} */
  secretToken() {
    return this.readAttributeUnderscore("secret_token")
  }

  /** @returns {boolean} */
  hasSecretToken() {
    const value = this.secretToken()

    return this._isPresent(value)
  }
}
